import makeStyles from '@mui/styles/makeStyles';
import { rgba } from 'polished';

export const useStyles = makeStyles((theme) => ({
  dropdownFilter: {
    marginLeft: '24px',
    [theme.breakpoints.down('md')]: {
      marginLeft: '0',
      padding: '1px 0',
    },
  },
  filterRow: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    [theme.breakpoints.down('md')]: {
      gap: '6px',
      flexWrap: 'wrap',
      justifyContent: 'flex-end',
    },
  },
  timezoneLabel: {
    fontSize: '12px',
    color: rgba(0, 0, 0, 0.55),
    whiteSpace: 'nowrap',
  },
  infoText: {
    fontSize: '3rem',
    color: '#282B31',
    fontWeight: 'bold',
  },
  taxesTitle: {
    fontSize: '20px',
    fontWeight: '500',
  },
  taxesColumnTitle: {
    fontSize: '12px',
    fontWeight: 600,
    color: '#171725',
    opacity: '0.4',
    flex: 1,
  },
  taxesInfo: {
    fontSize: '14px',
    fontWeight: '500',
    color: '#171725',
    opacity: '0.6',
    flex: 1,
  },
  bucketWrapper: {
    marginBottom: '12px',
  },
  breakdownWrapper: {
    marginTop: '6px',
    marginLeft: '32px',
    padding: '8px 12px',
    background: '#F5F7FA',
    borderRadius: '6px',
  },
  breakdownRow: {
    display: 'flex',
    justifyContent: 'space-between',
    padding: '3px 0',
  },
  breakdownLabel: {
    fontSize: '13px',
    fontWeight: 500,
    color: '#171725',
    opacity: 0.75,
  },
  breakdownRate: {
    opacity: 0.5,
    fontWeight: 400,
  },
  breakdownAmount: {
    fontSize: '13px',
    fontWeight: 600,
    color: '#171725',
    fontVariantNumeric: 'tabular-nums',
  },
  viewOrdersRow: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginTop: '4px',
  },
  ordersPanel: {
    marginTop: '8px',
    padding: '8px 12px',
    background: '#FFFFFF',
    border: '1px solid #E6E8EC',
    borderRadius: '6px',
  },
  ordersHeader: {
    display: 'grid',
    gridTemplateColumns: '1.4fr 1.2fr 1fr 1fr',
    columnGap: '12px',
    paddingBottom: '4px',
    borderBottom: '1px solid #F0F0F0',
  },
  ordersColumnTitle: {
    fontSize: '12px',
    fontWeight: 600,
    color: '#171725',
    opacity: 0.4,
  },
  ordersRow: {
    display: 'grid',
    gridTemplateColumns: '1.4fr 1.2fr 1fr 1fr',
    columnGap: '12px',
    padding: '4px 0',
    borderBottom: '1px solid #F7F8FA',
  },
  ordersCell: {
    fontSize: '13px',
    color: '#171725',
    fontVariantNumeric: 'tabular-nums',
  },
  ordersEmpty: {
    fontSize: '13px',
    color: rgba(0, 0, 0, 0.55),
    padding: '8px 0',
    textAlign: 'center',
  },
}));
